import {SHOW, HIDE} from './contextMenuActions'

const initialState = {
    visible: false,
    component: null,
    componentProps: null,
    position: null,
    customHide: false,
};

export default function contextMenuReducer(state = initialState, action = {}) {
    switch (action.type) {
        case SHOW:
            return {
                ...state,
                visible: true,
                component: action.component,
                componentProps: action.componentProps,
                position: action.position,
                customHide: action.customHide
            };
        case HIDE:
            return {
                ...initialState
            };
        default:
            return state;
    }
}
